/**
 * Mobile Optimize Fields
 * Handles some mobile optimization tweaks for fields when viewed on a mobile device
 * 
 * Config Options
 * -- none
 */
define('components/mobile-optimize-fields',[
    'jquery',
    'logging',
    'utilities'
], function(jquery, logging, utilities) {
    'use strict';
    
    var _ModuleName = "Mobile Optimize Fields";
    var _config = {
        telephone: [
            "phone_number",
            "phone_home",
            "phone",
            "zip",
            "zip_code",
            "postal_code"
        ],
        email: [
            "email"
        ]
    }
    var init = function() { }
    
    var run = function() {
        if(utilities.IsMobile()) {
            logging.debug("Mobile device detected, Mobile Optimizing Fields", _ModuleName);
            // Update Fields for use with Numeric Input
            _updateType('tel', _config.telephone);
            // Update Fields for email input
            _updateType('email', _config.email);
        } else {
            logging.debug("Not a mobile device, so fields will not be mobile optimized", _ModuleName);
        }
    }

    var _updateType = function(type, ids) {
        for(var i = 0; i < ids.length; i++)  {
            var $elem = $("#" + ids[i]);
            if($elem.length) {
                var value = $elem.val(); // backup any value settings
                logging.debug("Found id " + $elem[0].id + " and setting type to " + type, _ModuleName);
                $elem[0].type = type;
                $elem.val(value); // restore any value settings
            }
        }
    }

    return {
        init: init,
        run: run
    }
});
